import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.object.to-string.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-tab', {
    staticClass: "mt-5",
    attrs: {
      "title": "Serviços (Opcional)",
      "active": _vm.isTheCurrentTab,
      "disabled": !_vm.isTheCurrentTab && !_vm.store.isUpdate
    },
    on: {
      "click": function click() {
        return _vm.store.currentTab = 4;
      }
    }
  }, [_c('ListaPrecoServicoSelect', {
    model: {
      value: _vm.selectedLista,
      callback: function callback($$v) {
        _vm.selectedLista = $$v;
      },
      expression: "selectedLista"
    }
  }), _c('b-row', {
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', {
    attrs: {
      "md": "10"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Serviço",
      "label-for": "servico"
    }
  }, [_c('VueSelect', {
    ref: "buscarServico",
    attrs: {
      "filterable": false,
      "options": _vm.servicosFetched
    },
    on: {
      "input": _vm.setServico,
      "search": _vm.onSearchServico
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-flex justify-content-between"
        }, [_c('div', [_vm._v(" " + _vm._s(option.discriminacao) + " ")])])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.discriminacao) + " ")])];
      }
    }]),
    model: {
      value: _vm.servicoSelected,
      callback: function callback($$v) {
        _vm.servicoSelected = $$v;
      },
      expression: "servicoSelected"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o serviço pelo nome ")])], 2)], 1)], 1)], 1), _c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "Quantidade",
      "label-for": "quantidade"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "id": "quantidade",
      "name": "quantidade"
    },
    model: {
      value: _vm.quantidade,
      callback: function callback($$v) {
        _vm.quantidade = $$v;
      },
      expression: "quantidade"
    }
  }, 'money', _vm.quantityOptions, false))], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "Unitário",
      "label-for": "unitario"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "id": "unitario",
      "name": "unitario"
    },
    model: {
      value: _vm.unitario,
      callback: function callback($$v) {
        _vm.unitario = $$v;
      },
      expression: "unitario"
    }
  }, 'money', _vm.priceOptions, false))], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "Total R$",
      "label-for": "total"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "id": "total",
      "name": "total"
    },
    model: {
      value: _vm.total,
      callback: function callback($$v) {
        _vm.total = $$v;
      },
      expression: "total"
    }
  }, 'money', _vm.priceOptions, false))], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "label-for": "add"
    }
  }, [_vm.isHorimetroActive(_vm.servicoSelected && _vm.servicoSelected.horimetro) ? _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openCurrentHorimetroModal
    }
  }, [_c('ClockOutline', {
    staticClass: "btn btn-sm btn-warning btn-hover-warning btn-icon mr-2 mt-9",
    attrs: {
      "title": "Horímetro"
    }
  })], 1) : _vm._e(), _c('button', {
    on: {
      "click": function click($event) {
        return _vm.addServico(_vm.servicoSelected);
      }
    }
  }, [_c('Plus', {
    staticClass: "btn btn-sm btn-info btn-hover-info btn-icon mr-2 mt-9"
  })], 1)])], 1)], 1), _c('b-row', [_c('b-col', [_c('TableApp', {
    key: _vm.keyToRender,
    ref: "nome",
    attrs: {
      "item": "serviço",
      "subTitulo": "",
      "data": _vm.servicos,
      "fields": _vm.fields,
      "classFilterColumn": "nome"
    },
    scopedSlots: _vm._u([{
      key: "customRow",
      fn: function fn(props) {
        return [props.field == 'discriminacao' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "discriminacao"
          },
          slot: "discriminacao"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(props.rowData.discriminacao) + " ")])])]) : _vm._e(), props.field == 'quantidade' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "quantidade"
          },
          slot: "quantidade"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(_vm.numberToReal(props.rowData.quantidade)) + " ")])])]) : _vm._e(), props.field == 'unitario' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "unitario"
          },
          slot: "unitario"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(_vm.numberToReal(props.rowData.unitario)) + " ")])])]) : _vm._e(), props.field == 'total' ? _c('span', {
          staticClass: "text-dark-75 font-weight-bolder d-block font-size-lg",
          attrs: {
            "slot": "total",
            "disabled": ""
          },
          slot: "total"
        }, [_vm._v(" R$ " + _vm._s(_vm.numberToReal(props.rowData.total, 2)) + " ")]) : _vm._e(), props.field == 'actions' ? _c('span', {
          attrs: {
            "slot": "actions"
          },
          slot: "actions"
        }, [_c('div', {
          staticClass: "row-actions",
          staticStyle: {
            "text-align": "right !important"
          }
        }, [_c('span', {
          staticStyle: {
            "overflow": "visible",
            "position": "relative",
            "width": "170px"
          }
        }, [_c('div', {
          staticClass: "action-buttons"
        }, [_c('button', {
          staticClass: "btn btn-sm btn-info btn-hover-info btn-icon mr-2",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click($event) {
              return _vm.openModalServico(props.rowData, props.rowData.originalIndex);
            }
          }
        }, [_c('Pencil', {
          attrs: {
            "size": 16,
            "title": "Editar"
          }
        })], 1), _vm.isHorimetroActive(props.rowData.horimetro) ? _c('button', {
          staticClass: "btn btn-sm btn-warning btn-hover-warning btn-icon mr-2",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click($event) {
              return _vm.openModalHorimetro(props.rowData, props.rowData.originalIndex);
            }
          }
        }, [_c('ClockOutline', {
          attrs: {
            "size": 16,
            "title": "Horímetro"
          }
        })], 1) : _vm._e(), _c('button', {
          staticClass: "btn btn-sm btn-danger btn-hover-danger btn-icon mr-2",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click($event) {
              return _vm.handleDeleteServico(props.rowData);
            }
          }
        }, [_c('TrashCanIcon', {
          attrs: {
            "size": 16
          }
        })], 1)])])])]) : _vm._e()];
      }
    }])
  }), _vm.servicos.length > 0 ? _c('b-row', [_c('b-col'), _c('b-col'), _c('b-col', [_c('span', {
    staticClass: "text-primary font-weight-bolder"
  }, [_vm._v("Total Serviços:")]), _vm._v(" " + _vm._s(_vm.servicos.reduce(function (acc, servico) {
    return acc + servico.quantidade;
  }, 0)))]), _c('b-col', [_c('span', {
    staticClass: "text-primary font-weight-bolder"
  }, [_vm._v("Total R$:")]), _vm._v(_vm._s(_vm.numberToReal(_vm.servicos.reduce(function (acc, servico) {
    return acc + servico.total;
  }, 0), "preco")))])], 1) : _vm._e(), _vm.modalServicoIsOpen ? _c('ModalServico', {
    attrs: {
      "close": _vm.closeModalServico,
      "changeServico": _vm.saveEditProduto,
      "servico": _vm.servicoToEdit,
      "open": _vm.modalServicoIsOpen
    }
  }) : _vm._e(), _c('b-modal', {
    attrs: {
      "title": "Horímetro",
      "centered": "",
      "hide-footer": "",
      "hide-header-close": "",
      "no-close-on-backdrop": "",
      "no-close-on-esc": "",
      "size": "lg"
    },
    model: {
      value: _vm.modalHorimetroIsOpen,
      callback: function callback($$v) {
        _vm.modalHorimetroIsOpen = $$v;
      },
      expression: "modalHorimetroIsOpen"
    }
  }, [_c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "Tipo"
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "options": _vm.horimetroTipoOptions,
      "buttons": "",
      "button-variant": "outline-primary"
    },
    model: {
      value: _vm.horimetroForm.tipo,
      callback: function callback($$v) {
        _vm.$set(_vm.horimetroForm, "tipo", $$v);
      },
      expression: "horimetroForm.tipo"
    }
  })], 1)], 1)], 1), _vm.horimetroForm.tipo === 'horimetro' ? _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Horímetro inicial",
      "label-for": "horimetro_inicial"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "id": "horimetro_inicial",
      "name": "horimetro_inicial"
    },
    model: {
      value: _vm.horimetroForm.horimetroInicial,
      callback: function callback($$v) {
        _vm.$set(_vm.horimetroForm, "horimetroInicial", $$v);
      },
      expression: "horimetroForm.horimetroInicial"
    }
  }, 'money', _vm.quantityOptions, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Horímetro final",
      "label-for": "horimetro_final"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "id": "horimetro_final",
      "name": "horimetro_final"
    },
    model: {
      value: _vm.horimetroForm.horimetroFinal,
      callback: function callback($$v) {
        _vm.$set(_vm.horimetroForm, "horimetroFinal", $$v);
      },
      expression: "horimetroForm.horimetroFinal"
    }
  }, 'money', _vm.quantityOptions, false))], 1)], 1)], 1) : _vm._e(), _vm.horimetroForm.tipo === 'manual' ? _c('div', [_c('b-row', {
    staticClass: "mb-4"
  }, [_c('b-col', [_c('button', {
    staticClass: "btn btn-sm btn-info font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addHoraManual
    }
  }, [_vm._v(" + Hora ")])])], 1), _vm._l(_vm.horimetroForm.horas, function (hora, index) {
    return _c('b-row', {
      key: index,
      staticClass: "align-items-center"
    }, [_c('b-col', {
      attrs: {
        "md": "2"
      }
    }, [_c('strong', [_vm._v("Horário " + _vm._s(index + 1))])]), _c('b-col', {
      attrs: {
        "md": "4"
      }
    }, [_c('b-form-group', {
      attrs: {
        "label": "Hora inicial",
        "label-for": "manual_hora_inicio_".concat(index)
      }
    }, [_c('b-form-input', {
      directives: [{
        name: "mask",
        rawName: "v-mask",
        value: '##:##',
        expression: "'##:##'"
      }],
      attrs: {
        "id": "manual_hora_inicio_".concat(index),
        "type": "text",
        "inputmode": "numeric",
        "placeholder": "00:00"
      },
      model: {
        value: hora.inicio,
        callback: function callback($$v) {
          _vm.$set(hora, "inicio", $$v);
        },
        expression: "hora.inicio"
      }
    })], 1)], 1), _c('b-col', {
      attrs: {
        "md": "4"
      }
    }, [_c('b-form-group', {
      attrs: {
        "label": "Hora final",
        "label-for": "manual_hora_fim_".concat(index)
      }
    }, [_c('b-form-input', {
      directives: [{
        name: "mask",
        rawName: "v-mask",
        value: '##:##',
        expression: "'##:##'"
      }],
      attrs: {
        "id": "manual_hora_fim_".concat(index),
        "type": "text",
        "inputmode": "numeric",
        "placeholder": "00:00"
      },
      model: {
        value: hora.fim,
        callback: function callback($$v) {
          _vm.$set(hora, "fim", $$v);
        },
        expression: "hora.fim"
      }
    })], 1)], 1), _c('b-col', {
      attrs: {
        "md": "2"
      }
    }, [_c('button', {
      staticClass: "btn btn-sm btn-danger btn-hover-danger btn-icon mt-4",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.removeHoraManual(index);
        }
      }
    }, [_c('TrashCanIcon', {
      attrs: {
        "size": 16
      }
    })], 1)])], 1);
  })], 2) : _vm._e(), _c('div', {
    staticClass: "d-flex justify-content-end mt-5"
  }, [_c('button', {
    staticClass: "btn btn-clean font-weight-bold mr-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelHorimetro
    }
  }, [_vm._v(" Cancelar ")]), _c('button', {
    staticClass: "btn btn-primary font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveHorimetro
    }
  }, [_vm._v(" Salvar ")])])], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };